<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>添加模板</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>配电箱</el-breadcrumb-item> -->
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="build-bar">
        <span>设备名称：</span>
        <el-input placeholder="请输入模板名称" v-model="temName"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="doFilter"
          >查询</el-button
        >
        <el-button type="primary" @click="addRow()">添加模板</el-button>
        <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
      </div>
      <div class="main-table">
        <el-table
          :data="tableDataEnd"
          height="100%"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
        >
          <template slot="empty">
            <p>{{ dataText }}</p>
          </template>
          <el-table-column
            label="序号"
            type="index"
            width="100"
          ></el-table-column>
          <el-table-column label="设备名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:edit')"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:del')"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="35%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="100px"
        :label-position="labelPosition"
        :rules="rules"
      >
        <el-form-item label="模板名称：">
          <el-input
            v-model="addForm.name"
            placeholder="请输入模板名称"
            autocomplete="off"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单" prop="sn" style="">
          <div
            v-for="(item, index) in columns"
            :key="index"
            style="margin-bottom: 10px"
          >
            <el-input
              v-model="item.columnName"
              placeholder="请输入菜单名称"
              autocomplete="off"
              style="width: 200px; margin-right: 10px"
            ></el-input>
            <el-select v-model="item.type" clearable placeholder="请选择类型">
              <el-option key="1" label="文字" value="1"></el-option>
              <el-option key="2" label="图片" value="2"></el-option>
            </el-select>
            <div class="icon">
              <i
                class="el-icon-circle-plus-outline"
                @click="add"
                style="color: #296dd3; font-size: 3vh; cursor: pointer"
                alt=""
                srcset=""
              ></i>
              <i
                class="el-icon-delete"
                @click="reduce(item.index)"
                style="color: red; font-size: 3vh; cursor: pointer"
              ></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVis = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 二维码弹出框 -->
    <el-dialog
      :title="codeTit"
      :visible.sync="codeVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
      style="height: 100%"
    >
      <div class="erCode">
        <vue-qr :text="codeUrl" :size="200"></vue-qr>
        <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      temName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      groupId: '',
      dataText: '数据加载中...',
      addVis: false,
      dialogTitle: '',
      labelPosition: 'right',
      addForm: {
        id: '',
        type: '',
        name:''
      },
      uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
      uploadHead1: {
        accessToken: util.session.get('token'),
      },
      rules: {
        // sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
      },
      //二维码
      codeVis: false,
      codeUrl: '',
      codeTit: '',
      icon: '', //配电箱图
      http: base.httpCtx,
      unitType: [
        { name: '文字', vuale: '1' },
        { name: '图片', value: '2' },
      ],
      columns: [{ columnName: '', type: '', index: 0 }],
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.addForm.projectId = this.groupId
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      myHttp
        .getProFacilityTemplateList({
          name: this.temName,
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.proFacilityTemplate.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].thumbnailUrl =
                list[i].thumbnailUrl && list[i].thumbnailUrl != ''
                  ? list[i].thumbnailUrl
                  : ''
              list[i].srcList =
                list[i].thumbnailUrl && list[i].thumbnailUrl != ''
                  ? [base.httpCtx + list[i].thumbnailUrl]
                  : []
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.proFacilityTemplate.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //查询
    doFilter() {
      this.currentPage = 1
      this.getData()
    },

    //添加
    addRow() {
      this.addVis = true
      this.columns = [{ columnName: '', type: '', index: 0 }]
      this.addForm.name = ''
      this.addForm.id == ''
    },
    //编辑
    handleEdit(index, row) {
      this.addVis = true
      this.addForm.id = row.id
      this.columns = JSON.parse(row.columns)
      this.addForm.name = row.name
    },
    //删除
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp
          .deleteProFacilityTemplate({
            id: row.id,
            updateBy: util.session.get('user').id,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    //提交
    sumbitAddRow(formName) {
      var that = this
      console.log(this.columns)
      var columns = JSON.stringify(this.columns)
      console.log(columns)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //console.log(that.addForm.id)
          if (that.addForm.id == '') {
            myHttp
              .createProFacilityTemplate({
                projectId: this.groupId,
                name: this.addForm.name,
                columns: columns,
                createBy: util.session.get('user').id,
              })
              .then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addVis = false
                    that.currentPage = 1
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {}
              )
          } else {
            that.addForm.updateBy = util.session.get('user').id
            myHttp
              .updateProFacilityTemplate({
                id: this.addForm.id,
                projectId: this.groupId,
                name: this.addForm.name,
                columns: columns,
                updateBy: util.session.get('user').id,
              })
              .then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addVis = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {}
              )
          }
        }
      })
    },

    //展示二维码
    erCode(index, row) {
      this.codeVis = true
      this.codeUrl = '/pages/equipCheck/equipCheck?snId=' + row.sn
      this.codeTit = row.location
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      // var flag = util.common.filterBtnMenu(row)
      // return flag
      return true
    },

    /**
     * 获取历史记录
     */
    history(index, row) {
      this.$router.push({ path: '/eleBoxHistory/' + row.sn })
    },
    // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      console.log(res.data)
      this.addForm.photoUrl = res.data.savePhotoUrls
      this.addForm.thumbnailUrl = res.data.saveThumbnailUrls
    },
    // 增加预付款
    add() {
      var list = this.columns
      var length = list.length
      var ind = list[length - 1].index
      var obj = { columnName: '', type: '', index: parseInt(ind) + 1 }
      list.push(obj)
    },
    reduce(index) {
      var list = this.columns
      if (list.length != 0) {
        list.splice(index, 1)
        console.log(list.length)
      }
    },
  },
}
</script>

<style scoped>
.main {
  flex-wrap: wrap;
  align-content: flex-start;
}
.main-table {
  width: 100%;
  height: calc(100% - 11.4vh);
}
.build-bar {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  border-bottom: 3px solid #17b2fe;
  background: #fff;
}

.build-bar span {
  margin-left: 30px;
  white-space: nowrap;
  display: inline-block;
}

.build-bar > .el-input {
  width: 200px;
  font-size: 12px;
}
.build-bar > .el-button {
  margin-left: 30px;
  /* background-color: #17b2fe;
        border-color: #17b2fe; */
}
.erCode {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.avatar {
  width: 100%;
}
.recommends-content-item {
  /* width: 33%;
    height: 280px;
    margin-right: 1rem; */
  /* height: 15rem; */

  position: relative;
}
.recommends-content-item:hover .recommends-content-item__info {
  opacity: 1;
  transform: translateY(0);
}
.recommends-content-item__info {
  /* position: absolute;
    bottom: 0;
    color: rgba(255, 255, 255, 0.8); */
  /* background: rgba(34,34,34,0.35); */
  padding: 0 0.5rem;
  text-align: center;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  transition: 0.3s;
  opacity: 0;
  transform: translateY(100%);
}
.clounm {
  display: flex;
  align-items: center;
}
.icon {
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<style>
@import '../../../assets/css/common.css';
</style>